<div class="quote-card">
  <section class="quote-card__content">
    <div class="quote-card__header">
      <h2 class="quote-card__heading">Hi, {{ clientName }}</h2>
    </div>
    <div class="quote-card__body">
      <h3 class="quote-card__subheading">
        {{ greeting }}
      </h3>
      <div *ngIf="false" class="quote-card__spinner-container">
        <img class="quote-card__spinner" src="/img/components/transition-card/loading-spinner-white.gif" />
      </div>
      <div class="quote-info">
        <div class="quote-info__column">
          <div class="quote-info__details">
            <!--Insured -->
            <h4 class="quote-info__details-heading">Insured</h4>
            <span class="quote-info__name">{{ insuredName }}</span>
          </div>
          <div class="quote-info__details" *ngIf="shouldShowPremium">
            <div class="quote-info__details">
              <div class="quote-info__details-tooltip">
                <h4 class="quote-info__details-heading">{{ premiumLabel }}</h4>
                <client-cost-breakdown
                  *ngIf="!!insuredInfo"
                  [safeInviteInfo]="insuredInfo"
                  class="quote-info__details-breakdown"
                ></client-cost-breakdown>
              </div>
              <div class="quote-info__name">
                <p>
                  <span class="quote-info__premium-amount-dollar-sign">$ </span>
                  <span
                    >{{ totalPremium | casCurrency: 2:false }}
                    <span class="quote-info__frequency"> /{{ frequencyUnit }} </span>
                  </span>
                </p>
                <div *ngIf="hasExchange1035TowardsPremium()" class="quote-info__details-text">
                  <span>{{ totalPremium - exchange1035Premium | casCurrency }} due for initial premium</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="quote-info__divider"></div>
        <div class="quote-info__column">
          <div class="quote-info__details">
            <h4 class="quote-info__details-heading">
              <span *ngIf="hasAlir">Initial </span>
              <span>Coverage</span>
            </h4>
            <div class="quote-info__face-amount">
              <span class="quote-info__face-amount--dollar-sign">$ </span>
              <span>{{ totalCoverage | casCurrency: 0:false }}</span>
            </div>
          </div>
          <ng-container *ngIf="hasWholeLifePolicy">
            <h4 class="quote-info__details-heading">Product</h4>
            <div class="quote-info__details-item">
              <h4 class="quote-info__details-text">MassMutual Whole Life {{ wholeTerm }}</h4>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="!nbDecommissionPost30Days" class="quote-card__footer">
      <quote-card-conversion-text-description *ngIf="shouldShowPremium"></quote-card-conversion-text-description>
      <div class="quote-card__apply-now-button-container">
        <button cpdsButton theme="mm-dark" class="quote-card__apply-now-button" (click)="applyWithQuote()">
          Finish Now
        </button>
      </div>
    </div>
    <div *ngIf="!nbDecommissionPost30Days">
      <p class="quote-card__solicitation-disclaimer">
        MassMutual is licensed to sell insurance products in all 50 states of the United States (including the District
        of Columbia) and Puerto Rico (collectively, the “US”). By clicking “Finish Now,” you are confirming that you are
        currently located in the US.
        <b>If you are not located in the US, please do not continue with this application.</b>
        If we determine that you were located outside of the US at the time you completed this application, you
        understand and agree that we
        <b><u>will not</u></b>
        issue a policy to you and/or we may rescind any coverage issued in connection with this application.
      </p>
    </div>
    <div *ngIf="nbDecommissionPost30Days">
      <p class="quote-card__solicitation-disclaimer">
        MassMutual is licensed to sell insurance products in all 50 states of the United States (including the District
        of Columbia) and Puerto Rico (collectively, the “US”).
        <b>If you are not located in the US, please do not continue with this application.</b>
        If we determine that you were located outside of the US at the time you completed this application, you
        understand and agree that we
        <b><u>will not</u></b>
        issue a policy to you and/or we may rescind any coverage issued in connection with this application.
      </p>
    </div>
    <whole-life-visualization *ngIf="showWholeLifeVisualization && shouldShowPremium"></whole-life-visualization>
  </section>
</div>
